import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable()
export class ResellerAdminGuard implements CanActivate {

    constructor(private authService: AuthService,
        private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.authService.getLoggedInUser();
        if (user && user.clientIsReseller && user.clientAdmin) {
            return true;
        }
        this.router.navigate(['/dashboard']);
        return false;
    }
}
